// NB: pushes touching apps/portal-react auto-publish to staging
// /var/www/portal-spa via the bare-repo post-receive hook (md-only
// diffs are ignored). See code/CLAUDE.md → Deployment.
// Build marker: lets support/devtools confirm which bundle nginx
// serves (a bare comment dies in minification — this survives).
document.documentElement.dataset.ebPortalBuild = "2026-06-11-hook-verify-2";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";

import { App } from "./App";
import { queryClient } from "./lib/queryClient";
import "./i18n";

import "./index.css";

const rootEl = document.getElementById("root");
if (rootEl === null) {
  throw new Error("#root element missing from index.html");
}

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
